/** Caitlyn AbilitySpec seed kit (wiki-aligned W trap). */
import {
  CAITLYN_W_COOLDOWN,
  CAITLYN_W_DURATION_SEC,
  CAITLYN_W_EFFECT_DELAY_SEC,
  CAITLYN_W_MANA,
  CAITLYN_W_RANGE,
  CAITLYN_W_RECHARGE,
  CAITLYN_W_ROOT_SEC,
  CAITLYN_W_TRAP_RADIUS
} from '../params/caitlynParams.js';

export const CAITLYN_ABILITY_DEFS = [
  {
    id: 'caitlyn_q',
    champKey: 'caitlyn',
    slot: 'Q',
    name: 'Piltover Peacemaker',
    targeting: 'skillshot_line',
    range: 1300,
    castTime: 0.625,
    travelSpeed: 2200,
    width: 120,
    radius: 60,
    cooldown: 10,
    manaCost: 55,
    vfxId: 'caitlyn_q',
    status: 'wired'
  },
  {
    id: 'caitlyn_w',
    champKey: 'caitlyn',
    slot: 'W',
    name: 'Yordle Snap Trap',
    targeting: 'ground_aoe',
    range: CAITLYN_W_RANGE,
    castTime: 0.25,
    effectDelay: CAITLYN_W_EFFECT_DELAY_SEC,
    duration: CAITLYN_W_DURATION_SEC,
    collisionRadius: CAITLYN_W_TRAP_RADIUS,
    radius: CAITLYN_W_TRAP_RADIUS,
    cooldown: CAITLYN_W_COOLDOWN,
    recharge: CAITLYN_W_RECHARGE,
    manaCost: CAITLYN_W_MANA,
    vfxId: 'caitlyn_w',
    cc: { type: 'root', duration: CAITLYN_W_ROOT_SEC },
    status: 'wired'
  },
  {
    id: 'caitlyn_e',
    champKey: 'caitlyn',
    slot: 'E',
    name: '90 Caliber Net',
    targeting: 'skillshot_line',
    range: 800,
    castTime: 0.15,
    travelSpeed: 1600,
    width: null,
    radius: 14,
    cooldown: 16,
    manaCost: 75,
    vfxId: 'caitlyn_e',
    status: 'wired'
  },
  {
    id: 'caitlyn_r',
    champKey: 'caitlyn',
    slot: 'R',
    name: 'Ace in the Hole',
    targeting: 'targeted',
    range: 3500,
    castTime: 0.375,
    travelSpeed: 3200,
    width: null,
    radius: null,
    cooldown: 90,
    manaCost: 100,
    vfxId: 'caitlyn_r',
    status: 'wired'
  }
];
